export default "__VITE_ASSET__CCz3kYAD__"